<template>
  <div id="partner-box-type-item">
    <div class="card-wrapper" @click="expandPanel">
      <basic-card class="partner-box-type-card">
        <div class="box-image">
          <img
            height="25px"
            :src="`/static/icons/boxes/${$variables.boxTypes[type]}_box.svg`"
          />
        </div>
        <div class="box-type">{{ $variables.boxTypes[type] }}:</div>
        <div class="boxes-count">
          {{
            $t("partnerBoxTypeItem.boxTypes.boxCount", { count: boxes.length })
          }}
        </div>
        <div class="moving-boxes-count">
          {{
            $t("partnerBoxTypeItem.boxTypes.movingBoxCount", {
              count: movingBoxes.length
            })
          }}
        </div>
        <div class="action-wrapper">
          <div @click.stop="toggleMoving" v-show="showAllSelectorButton">
            <transition name="fade" mode="out-in">
              <template v-if="moveAll">
                <div class="move-all-box action-text" :key="0">
                  {{ $t("partnerBoxTypeItem.boxTypes.moveAll") }}
                </div>
              </template>
              <template v-if="!moveAll">
                <div class="leave-all-box action-text" :key="1">
                  {{ $t("partnerBoxTypeItem.boxTypes.leaveAll") }}
                </div>
              </template>
            </transition>
          </div>
        </div>
      </basic-card>
    </div>
    <div ref="expand-panel" class="expandable-panel">
      <transition name="list">
        <div v-if="expanded" class="box-wrapper">
          <partner-box-item
            class="box"
            v-for="(item, index) in boxes"
            :key="index"
            :box="item"
            :isMoving="isMovingBoxes(item)"
            @remove="removeBox"
            @add="addBox"
          />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PartnerBoxItem from "./PartnerBoxItem";
export default {
  name: "PartnerBoxTypeItem",
  props: {
    boxes: {
      type: Array,
      required: true
    },
    type: {
      type: [Number, String],
      required: true
    }
  },
  components: {
    PartnerBoxItem
  },
  data: () => ({
    moveAll: true,
    expanded: false,
    movingBoxes: []
  }),
  mounted() {
    if (this.partnerSavedBoxes !== undefined) {
      this.movingBoxes = this.partnerSavedBoxes.map(x => x.QRNumber);
    } else {
      this.movingBoxes = [...this.boxes.map(x => x.QRNumber)];
    }
    if (this.movingBoxes.length === 0) {
      this.moveAll = false;
    }
  },
  watch: {
    partnerSavedBoxes() {
      if (this.partnerSavedBoxes !== undefined) {
        this.movingBoxes = this.partnerSavedBoxes.map(x => x.QRNumber);
      } else {
        this.movingBoxes = [...this.boxes.map(x => x.QRNumber)];
      }
    },
    boxes() {
      if (this.partnerSavedBoxes !== undefined) {
        this.movingBoxes = this.partnerSavedBoxes.map(x => x.QRNumber);
      } else {
        this.movingBoxes = [...this.boxes.map(x => x.QRNumber)];
      }
    },
    movingBoxes() {
      if (this.movingBoxes.length === 0) {
        this.moveAll = false;
      } else {
        this.moveAll = true;
      }
    }
  },
  computed: {
    ...mapGetters({
      getPartnerMovingBoxes: "moving/getPartnerMovingBoxes",
      getPartner: "moving/getPartner"
    }),
    partnerSavedBoxes() {
      if (this.getPartnerMovingBoxes) {
        return this.getPartnerMovingBoxes.filter(x => x.type == this.type);
      } else {
        return this.getPartnerMovingBoxes;
      }
    },
    showAllSelectorButton() {
      return (
        (this.movingBoxes.length === 0 ||
          this.boxes.length == this.movingBoxes.length) &&
        this.boxes.length !== 0 &&
        this.getPartner.moved &&
        this.getPartner.moved == 1
      );
    }
  },
  methods: {
    isMovingBoxes(item) {
      const index = this.movingBoxes.findIndex(el => {
        return el == item;
      });
      return index !== -1;
    },
    addBox(payload) {
      const index = this.movingBoxes.findIndex(el => {
        return el == payload;
      });
      if (index == -1) {
        this.movingBoxes.push(payload);
      }
    },
    removeBox(payload) {
      const index = this.movingBoxes.findIndex(el => {
        return el == payload;
      });
      if (index !== -1) {
        this.movingBoxes.splice(index, 1);
      }
    },
    addAllBoxes() {
      this.movingBoxes = [...this.boxes.map(x => x.QRNumber)];
    },
    removeAllBoxes() {
      this.movingBoxes = [];
    },
    toggleMoving() {
      this.moveAll = !this.moveAll;
      if (this.moveAll) {
        this.addAllBoxes();
      } else {
        this.removeAllBoxes();
      }
    },
    expandPanel() {
      this.expanded = !this.expanded;
      // const maxHeight = this.expanded ? 500 : 0;
      // this.$refs["expand-panel"].style["max-height"] = maxHeight + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#partner-box-type-item {
  margin-bottom: 10px;
  .partner-box-type-card {
    cursor: pointer;
    width: 100%;
    padding: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .box-image {
      margin-right: 15px;
    }
    .box-type {
      margin-right: 5px;
      font-weight: bold;
    }
    .boxes-count {
      margin-right: 15px;
    }
    .moving-boxes-count {
      margin-right: auto;
      margin-left: auto;
    }
    .action-wrapper {
      cursor: pointer;
      margin-right: 10px;
      margin-left: auto;
      min-width: 100px;
      .action-text {
        font-size: 13px;
        text-align: center;
        font-weight: 550;
        color: $color-font-grey-color;
      }
    }
  }
  .expandable-panel {
    transition: all 0.3s ease-in-out;
    height: fit-content;
    // max-height: 0;
    overflow: hidden;
  }
}
</style>
